import { pluck } from 'ramda'
import type { Provider } from '../PreCheckedProviders.types'

/**
 * Checks the list of providers for multiple categories. Will be used to display
 * the description underneath the provider name if true
 *
 * @param providers Array of providers
 * @returns True if there are multiple categories, false otherwise
 */
export const checkMultipleCategoryNames = (providers: Provider[]): boolean => {
  const categories = pluck('categoryName', providers)
  const uniqueCategories = Array.from(new Set(categories))

  return uniqueCategories.length > 1
}
